import {
  TKPI,
  TLineGraph,
  TTableauGlobal,
  TTableauGlobalResilie,
  TTableauSecteur,
} from "@/features/profile/types/profile.types";
import dashboardTypes from "./dashboard.types";

interface IUpdateKPI {
  type: dashboardTypes.UPDATE_KPI;
  payload: TKPI;
}

interface IUpdateLineGraphResiliation {
  type: dashboardTypes.UPDATE_LINE_CHART_RESILIATION;
  payload: TLineGraph;
}

interface IUpdateLineGraphAbonnement {
  type: dashboardTypes.UPDATE_LINE_CHART_ABONNEMENT;
  payload: TLineGraph;
}

interface IUpdateTableauSecteur {
  type: dashboardTypes.UPDATE_TABLEAU_SECTEUR;
  payload: TTableauSecteur;
}

interface IUpdateTableauGlobale {
  type: dashboardTypes.UPDATE_TABLEAU_GLOBAL;
  payload: TTableauGlobal;
}
interface IUpdateTableauGlobaleResilie {
  type: dashboardTypes.UPDATE_TABLEAU_GLOBAL_RESILIE;
  payload: TTableauGlobalResilie;
}

interface IIsDashboardLoading {
  type: dashboardTypes.IS_LOADING_DASHBOARD;
  payload: boolean;
}

interface IIsLineChartAbonnementLoading {
  type: dashboardTypes.IS_LOADING_LINE_CHART_ABONNEMENT;
  payload: boolean;
}

interface IIsLineChartResiliationLoading {
  type: dashboardTypes.IS_LOADING_LINE_CHART_RESILIATION;
  payload: boolean;
}

export type DashboardAction =
  | IUpdateKPI
  | IUpdateLineGraphResiliation
  | IUpdateLineGraphAbonnement
  | IUpdateTableauSecteur
  | IUpdateTableauGlobale
  | IUpdateTableauGlobaleResilie
  | IIsDashboardLoading
  | IIsLineChartAbonnementLoading
  | IIsLineChartResiliationLoading;

export const updateKPI = (kpi: TKPI) => ({
  type: dashboardTypes.UPDATE_KPI,
  payload: kpi,
});

export const updateLineGraphResiliation = (
  lineGraphResiliation: TLineGraph | null
) => ({
  type: dashboardTypes.UPDATE_LINE_CHART_RESILIATION,
  payload: lineGraphResiliation,
});

export const updateLineGraphAbonnement = (
  lineGraphAbonnement: TLineGraph | null
) => ({
  type: dashboardTypes.UPDATE_LINE_CHART_ABONNEMENT,
  payload: lineGraphAbonnement,
});

export const updateTableauSecteur = (
  tableauSecteur: TTableauSecteur | null
) => ({
  type: dashboardTypes.UPDATE_TABLEAU_SECTEUR,
  payload: tableauSecteur,
});

export const updateTableauGlobal = (tableauGlobal: TTableauGlobal | null) => ({
  type: dashboardTypes.UPDATE_TABLEAU_GLOBAL,
  payload: tableauGlobal,
});

export const updateTableauGlobalResilie = (
  tableauGlobalResilie: TTableauGlobalResilie | null
) => ({
  type: dashboardTypes.UPDATE_TABLEAU_GLOBAL_RESILIE,
  payload: tableauGlobalResilie,
});

export const isDashboardLoading = (loading: boolean) => ({
  type: dashboardTypes.IS_LOADING_DASHBOARD,
  payload: loading,
});

export const isLineChartResiliationLoading = (loading: boolean) => ({
  type: dashboardTypes.IS_LOADING_LINE_CHART_RESILIATION,
  payload: loading,
});

export const isLineChartAbonnementLoading = (loading: boolean) => ({
  type: dashboardTypes.IS_LOADING_LINE_CHART_ABONNEMENT,
  payload: loading,
});
